import React from 'react';
import './Professionals Value Prop.css';

const ProfessionalsValueProp = () => {
  return (
    <section className="professionals-section">
      <div className="section-header">
        <p className="section-tagline">FOR PROFESSIONALS</p>
        <h2>How HyrEx helps your professional growth?</h2>
      </div>
      <div className="professionals-content">
        <div className="text-content">
          <ul>
            <li>
              <strong>Monetize knowledge:</strong> Top professionals could make $5k+ every month on HyrEx, through content direct sales and royalties.
            </li>
            <li>
              <strong>Exclusive network:</strong> Our invite-only / application-only model ensures only top industry professionals are part of the platform – limited to top 1% professionals of the world.
            </li>
            <li>
              <strong>Connect with like-minded professionals only:</strong> Avoid all the social media noise and make professional connections meaningful.
            </li>
          </ul>
        </div>
        <div className="image-content">
          
        <video
            src="./professional-video.mp4" // Replace with the actual path to your video file
            autoPlay
            loop
            muted
            playsInline
          >
            Your browser does not support the video tag.
          </video>

        </div>
      </div>
    </section>
  );
};

export default ProfessionalsValueProp;
